module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "5transparency.2ad7ee61.svg";